export default __webpack_public_path__ + "static/media/upload_news.31445b6c.svg";